import { render } from "./Index.vue?vue&type=template&id=4b840495&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4b840495&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\one8-web\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b840495"]])

export default __exports__